import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import posthog from 'posthog-js';

import { AppModule } from './app/app.module';
import { environment } from '@env';

// Enforce HTTPS in production
const isRedirectingToHttps =
  environment.production && typeof window !== 'undefined' && window.location?.protocol === 'http:';

if (isRedirectingToHttps) {
  window.location.replace(
    `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  if (environment.production) {
    enableProdMode();
  }

  // Initialize PostHog Analytics
  if (environment.posthogKey) {
    posthog.init(environment.posthogKey, {
      api_host: environment.posthogHost,
      person_profiles: 'identified_only',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      persistence: 'localStorage+cookie',
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
}
